import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["className", "displayOptimized", "data-test-id", "isTransitional", "onBlur"];
import UIFormControl from 'UIComponents/form/UIFormControl';
import { createTokenizedComponent } from './helpers';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useSendCrmMessageTopic } from 'crm-message-bus/useSendCrmMessageTopic';
import { TOPIC_NAMES } from 'crm-message-bus/types/MessageTopics';
import { Button } from 'foundations-components/transitional/components/Button';
import { useObjectId } from '../v2/hooks/useObjectId';
import { useObjectTypeId } from '../v2/hooks/useObjectTypeId';
import { useProperty } from '../v2/hooks/useProperty';
import { jsx as _jsx } from "react/jsx-runtime";
const TokenizedUIFormControl = createTokenizedComponent(UIFormControl);
function DetailsLinkButton() {
  const objectId = useObjectId();
  const objectTypeId = useObjectTypeId();
  const property = useProperty();
  const showPropertyHistoryPanel = useSendCrmMessageTopic(TOPIC_NAMES.OPEN_PROPERTY_HISTORY);
  const handleClick = () => {
    showPropertyHistoryPanel({
      objectTypeId,
      objectId: String(objectId),
      propertyNames: [property.name]
    });
  };
  return /*#__PURE__*/_jsx(Button, {
    use: "link",
    onClick: handleClick,
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "customerDataProperties.formControl.hoverContent"
    })
  });
}
export default function FormControlAdapter(_ref) {
  let {
      className,
      displayOptimized,
      'data-test-id': dataTestId,
      isTransitional,
      onBlur
    } = _ref,
    commonProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const adaptedOnBlur = onBlur ? event => onBlur(event) : undefined;
  if (displayOptimized) {
    return /*#__PURE__*/_jsx(FormControl, Object.assign({
      "data-test-id": dataTestId !== null && dataTestId !== void 0 ? dataTestId : 'DisplayOptimizedFormControl',
      displayOptimized: true,
      hoverContent: /*#__PURE__*/_jsx(DetailsLinkButton, {}),
      onBlur: adaptedOnBlur
    }, commonProps));
  }
  if (isTransitional) {
    return /*#__PURE__*/_jsx(FormControl, Object.assign({
      "data-test-id": dataTestId !== null && dataTestId !== void 0 ? dataTestId : 'FormControl',
      onBlur: adaptedOnBlur
    }, commonProps));
  }
  return /*#__PURE__*/_jsx(TokenizedUIFormControl, Object.assign({
    "data-test-id": dataTestId ? dataTestId === 'FormControlAdapter' ? 'UIFormControl' : dataTestId : 'UIFormControl',
    className: className,
    onBlur: adaptedOnBlur
  }, commonProps));
}